import { withInstall } from '@ll-plus/utils'

import Heatmap from './src/heatmap.vue'

export const LlHeatmap = withInstall(Heatmap)
export default LlHeatmap
export * from './src/heatmap'

declare module 'vue' {
	export interface GlobalComponents {
		LlHeatmap: typeof Heatmap
	}
}
